var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagRepublicOfTheCongo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67318 30.2277L20.4272 20.4273L30.2277 8.67321C28.704 5.72022 26.2878 3.30278 23.336 1.7771L11.5727 11.5728L1.77713 23.336C3.30269 26.2879 5.72012 28.704 8.67318 30.2277Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3137 27.3142C32.3615 22.2662 33.3306 14.6852 30.2228 8.66357L8.66309 30.2233C14.6847 33.331 22.2658 32.362 27.3137 27.3142Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6856 4.68557C-0.362263 9.73343 -1.33126 17.3145 1.77642 23.3362L23.3362 1.77645C17.3146 -1.33136 9.73347 -0.362235 4.6856 4.68557Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRepublicOfTheCongo);
export default __webpack_public_path__ + "static/media/flag_republic_of_the_congo.419b0d2e354ffe7b9f62101b3a7c83d1.svg";
export { ForwardRef as ReactComponent };